import React, { Component } from 'react';
import {Redirect } from 'react-router-dom';// Link, 
import { connect } from 'react-redux';
import { alertSuccess, noTimeOut } from '../actions/alertActions';
import { api } from '../services/rest';
//import { config } from '../config';
import BuildInProgress from './BuildInProgress';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { isNullOrUndefined } from 'util';

class Publish extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projectIsPublished: false,
            settings: [],
            totalBytes: 0,
            progressBytes: 0,
            files:[]
        }
        this.compileProject = this.compileProject.bind(this);
        this.getFiles = this.getFiles.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
    }

    async componentDidMount() {
        await api.get(`/${this.props.client}/${this.props.project}/ProjectSettings/Get`)
            .then((res) => { this.setState({ settings: res.data }) }, (error) => { console.log(error) });
        this.compileProject();
    }

    async getFiles() {
        var myThis = this;
        await api.get(`/${this.props.client}/${this.props.project}/FTPPublish/GetPublishFiles`)
            .then((res) => {
                var tempBytes;
                tempBytes = 0;
                var tempData;
                tempData = JSON.parse(res.data);
                console.log(tempData);
                for (var i = 0; i < tempData.length; i++) {
                    tempBytes = tempBytes + tempData[i].Size
                }
                myThis.setState({ files: tempData, totalBytes: tempBytes })
            }, (error) => { console.log(error) })
    }

    async uploadFile(file) {
        var myThis = this;
        await api.post(`/${this.props.client}/${this.props.project}/FTPPublish/Live`, { Name: file.Name, Size: file.Size})
        .then((res) => {
            myThis.setState({ progressBytes: myThis.state.progressBytes + file.Size })
        }, (error) => { console.log(error) });
    }

    async compileProject() {
        //console.log(this.props);
        var myThis = this;
        if (!isNullOrUndefined(this.state.settings.gulp)) {
            if ( !this.state.settings.gulp.useGulp) {
                //Get Files if state is empty
                if (this.state.files.length === 0) { await this.getFiles() }
                
                this.state.files.forEach(async (file) => {
                    try {
                        await this.uploadFile(file);
                        console.log(file);
                    }
                    catch (error) {
                        console.log(error);
                        console.log(file);
                    }
                });

            }
            if (this.state.settings.gulp.useGulp) {
                api.post(`/Publish/${this.props.client}/${this.props.project}/Live`)
                    .then(res => {
                        this.props.alertSuccess(<span>Your project has been published. You can view it at <a className="alert-link" href={res.data.url}>{res.data.url}</a>.</span>, noTimeOut);
                        this.setState({ projectIsPublished: true })
                    })
            }
        }
    }

    render() {        
        const redirect = <Redirect to={`/${this.props.client}/${this.props.project}`} />;
        const now = (this.state.progressBytes / this.state.totalBytes) * 100;
        const progress = (this.state.totalBytes > 0) ? <div className="FTPOuter"><ProgressBar className="FTPProgress" animated striped now={now} label={`${now.toFixed(2)}%`} /></div> : <div></div>;
        if (this.state.projectIsPublished) return redirect;
        else return <><BuildInProgress />{progress}</>
    }
}

export default connect(null, { alertSuccess })(Publish);
